module.exports = __webpack_public_path__ + "img/pic2.a0f7d691.png";